<div class="city-choice">
  <p class="city-choice__title">wybierz miasto</p>
  <button class="city-choice__btn flaticon-select" (click)="runGeolocalization()">{{"map.geolocation.run.text" | translate}}</button>
  <p class="city-choice__error-message -hidden" [ngClass]="{'-visible': geolocationDeny, '-hidden': !geolocationDeny}" [innerHTML]='"map.geolocation.deny.text" | translate'>
  </p>
  <v-input (changeVal)="onChangedInput($event)" (enterVal)="onEnterVal($event)" placeholderVal='{{"map.searchbox.placeholder.text" | translate}}'></v-input>
  <div class="city-choice__list">
    <div  *ngFor="let item of filteredItems" class="city-choice__list__item" [ngClass]="{'-selected': selectedCity === item}" (click)="newCity(item)">{{item}}</div>
  </div>
  <div *ngIf="showSelect" class="city-choice__select">
    <ng-select [items]="selectItems" (change)="onChangeSelect($event)" [placeholder]="'product.availability.select.placeholder' | translate" [notFoundText]="'ng-select.notFoundText' | translate"></ng-select>
  </div>
</div>
